import { ContentContainer } from "Admin/Components";
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import { contentList } from "./Components/contentList";
import styles from "./PersonalProfile.module.scss";
const PersonalProfile = () => {
  const pathname = useLocation().pathname;
  const [selectedTag, setSelectedTag] = useState(null);
  useEffect(() => {
    contentList.map((item, index) => {
      if (item.path == pathname) {
        setSelectedTag(contentList[index]);
      }
    });
  }, [pathname]);

  return (
    <div className={styles["personal-profile"]}>
      <ContentContainer
        items={contentList}
        selectedTag={selectedTag}
        setSelectedTag={setSelectedTag}
      />
    </div>
  );
};

export default PersonalProfile;
